import { render, staticRenderFns } from "./OpenIndicatorArrowIcon.vue?vue&type=template&id=fa576f2e"
import script from "./OpenIndicatorArrowIcon.vue?vue&type=script&lang=js"
export * from "./OpenIndicatorArrowIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports